import yn from "yn";

export const WITH_HOTJAR = yn(process.env.GATSBY_WITH_HOTJAR, { default: false });
export const useHotjar = process.env.GATSBY_ACTIVE_ENV === "production" || WITH_HOTJAR;
